import { dimensions, SvgIconProps } from "./SvgIcon";

export const DatabaseIcon = (props: SvgIconProps) => {
  const { width, height } = dimensions(props);
  return (
    <svg
      style={{ display: "block", ...props.style }}
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 3.33331C14 4.43788 11.3137 5.33331 8 5.33331C4.68629 5.33331 2 4.43788 2 3.33331M14 3.33331C14 2.22874 11.3137 1.33331 8 1.33331C4.68629 1.33331 2 2.22874 2 3.33331M14 3.33331V12.6666C14 13.7733 11.3333 14.6666 8 14.6666C4.66667 14.6666 2 13.7733 2 12.6666V3.33331M14 7.99998C14 9.10665 11.3333 9.99998 8 9.99998C4.66667 9.99998 2 9.10665 2 7.99998"
        stroke="currentColor"
        strokeOpacity="0.56"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
